import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "../style";
import { landslideIspraLegendLevels } from "./LandslideUtils";

export const LandslideNatcatRiskLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{`${t("riskAssessment.landslideRiskIspra")}`}</b>
      </div>
      <div>
        <span style={legendItemStyle("#F7F7F7")}></span>
        {landslideIspraLegendLevels().noHazard}
      </div>

      <div>
        <span style={legendItemStyle("#f5cb40")}></span>
        P1 - {landslideIspraLegendLevels().moderate}
      </div>
      <div>
        <span style={legendItemStyle("#e66800")}></span>
        P2 - {landslideIspraLegendLevels().medium}
      </div>
      <div>
        <span style={legendItemStyle("#feff73")}></span>
        AA - {landslideIspraLegendLevels().attentionZones}
      </div>
      <div>
        <span style={legendItemStyle("#e60200")}></span>
        P3 - {landslideIspraLegendLevels().high}
      </div>
      <div>
        <span style={legendItemStyle("#730102")}></span>
        P4 - {landslideIspraLegendLevels().veryHigh}
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from IdroGEO ISPRA (v. 4.0 – 2020-2021) processed by CyStellar
        </span>
      </div>
    </div>
  );
};
